import React from 'react';
import Avatar from '@mui/material/Avatar';

const CustomAvatar = ({ imageUrl, icon }) => {
    return (
        <div className="avatar_inner_container">
            {imageUrl ? (
                <Avatar
                    src={imageUrl}
                    sx={{ width: 65, height: 65 }} // Set size using sx prop
                />
            ) : (
                <Avatar
                    sx={{ width: 65, height: 65 }} // Set size using sx prop
                >
                    {icon}  {/* Render icon or initial letter */}
                </Avatar>
            )}
        </div>
    );
};

export default CustomAvatar;